import React, { useState, useEffect } from 'react';
import NewNav from '../components/NewNav';
import cleanVideo from "../images/newvideo.mp4";
import Footer from '../components/Footer';
import VerticalCards from '../components/VerticalCards';
import StepsSection from '../components/StepsSection';
import AutoSlider from '../components/AutoSlider';
import AOS from "aos";
import "aos/dist/aos.css";

import bulb1 from "../images/led2.jpg";
import bulb2 from "../images/downlight.jpg";
import bulb3 from "../images/panel-light.jpg";
import bulb4 from "../images/adju.jpeg";
import bulb7 from "../images/cob.jpeg";
import bulb8 from "../images/batten1.jpg";
import bulb9 from "../images/tube-ligh1.jpg";
import bulb10 from "../images/8.jpg"

import spotlight from "../images/spot-light.jpg";
import floodlight from "../images/flood.jpg";
import streetlight from "../images/street-light.jpg";
import HighbayLights from "../images/high-bay.jpg";
import tseriess from "../images/tseriess-light.jpg";
import tubelig from "../images/tube-light.jpg";
import stadium from "../images/stadium-light.jpg";
import solar from "../images/solar.jpg";

function NewHome() {
    const [isLoading, setIsLoading] = useState(true);

  const imagecon = [bulb1, bulb2, bulb3, bulb4, bulb7, bulb8, bulb9,bulb10];

  const imagespro = [spotlight, floodlight, streetlight,HighbayLights,tseriess,tubelig,stadium,solar];

  const [isHovered, setIsHovered] = useState(false);

  const messages = [
    "Illuminate Brilliance with  Orion Lighting <br/>Modern  Efficient. Sustainable.",
    "From architectural elegance <br/> to industrial strength.",
    "Crafted for performance <br/>Designed for impact.",
    "Every Space Tells a Story <br/> Let light be your narrator.",
    "Light That Works as Hard as You Do For <br/> warehouses, Offices,Landmarks."
  ];
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 4000);
    
    AOS.init({
      duration: 1000, // Animation duration ////...
      easing: "ease-in-out",
      once: true, // Ensures animation occurs only once //
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 5000); 
    return () => clearInterval(interval);
  }, []);
    if (isLoading) {
    return (
      <div className="preloader" style={{ backgroundColor: "#373838", display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", width: "100vw", position: "fixed", top: 0, left: 0, zIndex: 9999 }}>
        <h1 className="slogan" style={{ color: "white", textAlign: "center", fontSize: "2rem" }}>
          "Where illumination meets innovation"
        </h1>
      </div>
    );
  }

  return (
    <div className='new-home-wrapper'>
      <NewNav />
      <div className="container-fluid mx-auto">
        <div className="row">
          <div className="col-md-12 p-0">
            <div className="video-wrapper">
              <video autoPlay loop muted className="background-video responsive-video"  style={{ width: "100%", height: "auto", display: "block" }}>
                <source src={cleanVideo} type="video/mp4" />
              </video>
              <div className="video-overlay" style={{ display: "none" }}></div>

              {/* Dynamic Text */}
              <div className="video-text">
              <h3
                className="fade-in-text"
                dangerouslySetInnerHTML={{ __html: messages[currentMessageIndex] }}
              ></h3>
                  
              </div>

              {/* Image Slider */}
              <div
                className="slider-container"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <div className="slider-column">
                  <div className={`slider-track ${isHovered ? 'paused' : ''}`}>
                    {imagecon.map((img, i) => (
                      <div key={i} className="slider-img-box">
                        <img src={img} alt={`img-${i}`} />
                      </div>
                    ))}
                  </div>
                </div>
                <div className="slider-column">
                  <div className={`slider-track reverse ${isHovered ? 'paused' : ''}`}>
                    {imagespro.map((imgs, i) => (
                      <div key={i} className="slider-img-box">
                        <img src={imgs} alt={`img-${i}`} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <AutoSlider />
      <VerticalCards />
      <StepsSection />
      <Footer />
    </div>
  );
}

export default NewHome;
